import axios from "axios";

const baseAPI = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});

// Request interceptor: attach access token
baseAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers["Authorization"] = token;
  return config;
});

const BASE_URL = process.env.REACT_APP_API;

const api = axios.create({ baseURL: BASE_URL, withCredentials: true });

// attach the current access token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// one refresh at a time: parallel 401s all wait on the same request
let refreshPromise = null;

const refreshAccessToken = () => {
  if (!refreshPromise) {
    // plain axios, not `api`, so this call can't trigger the interceptor
    refreshPromise = axios
      .get(`${BASE_URL}auths/refresh`, null, { withCredentials: true })
      .then((res) => {
        const body = res.data;
        const newToken = body?.data?.accessToken ?? body?.accessToken;
        if (!newToken) throw new Error("No access token in refresh response");

        const stored = JSON.parse(localStorage.getItem("user") || "{}");
        const user = {
          ...stored,
          data: {
            ...stored.data,
            ...(body?.data || {}),
            accessToken: newToken,
          },
        };

        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token", newToken);
        // tell AuthContext so React state matches
        window.dispatchEvent(
          new CustomEvent("auth:refreshed", { detail: user }),
        );
        return newToken;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;

    const isAuthCall = /\/auths\/(login|refresh|logout)/.test(
      original?.url || "",
    );

    if (status !== 401 || !original || original._retry || isAuthCall) {
      return Promise.reject(error);
    }

    original._retry = true;
    try {
      const token = await refreshAccessToken();
      original.headers.Authorization = `Bearer ${token}`;
      return api(original);
    } catch {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      window.dispatchEvent(new Event("auth:logout"));
      return Promise.reject(error);
    }
  },
);

export { api, baseAPI };
